import zsmLayout from '@/zsm-layout'

const accountRouter = {
  path: '/account',
  component: zsmLayout,
  name: 'account',
  hidden: true,
  children: [{
    path: '/account',
    component: () => import('@/view/account/index'),
    name: 'account',
    children: [
      {
        path: '/account/setting',
        component: () => import('@/view/account/setting'),
        name: 'setting',
        hidden: true
      },

      {
        path: '/account/ksaccount',
        component: () => import('@/view/platform/ksaccount'),
        name: 'setting',
        hidden: true
      },
      {
        path: '/account/dyaccount',
        component: () => import('@/view/platform/dyaccount'),
        name: 'setting',
        hidden: true
      },
      {
        path: '/account/wxaccount',
        component: () => import('@/view/platform/wxaccount'),
        name: 'setting',
        hidden: true
      },
      {
        path: '/account/reset-password',
        component: () => import('@/view/account/reset-password'),
        name: 'setting',
        hidden: true
      },
      {
       redirect: '/certification/home',
        path: '/account/certification/company',
        component: () => import('@/view/account/company-certification2'),
        name: 'setting',
        hidden: true
      },
      {
       redirect: '/certification/home',
        path: '/account/certification',
        component: () => import('@/view/account/certification2'),
        name: 'setting',
        hidden: true
      },
      {
       redirect: '/certification/home',
        path: '/account/certification/type',
        component: () => import('@/view/account/upload-certification2'),
        name: 'setting',
        hidden: true
      },
      // {
      //   path: '/account/certification2/explain',
      //   component: () => import('@/view/account/explain-certification'),
      //   name: 'setting',
      //   hidden: true
      // },
      {
        path: '/account/copyright',
        component: () => import('@/view/account/copyright'),
        name: 'setting',
        hidden: true
      },
      {
       redirect: '/certification/home',
        path: '/account/certification/person',
        component: () => import('@/view/account/person-certification2'),
        name: 'setting',
        hidden: true
      },

      {
        path: '/account/employee',
        component: () => import('@/view/employee/index'),
        name: 'employee',
        hidden: true,
        redirect: '/account/employee/list',
        children: [
          {
            path: '/account/employee/list',
            component: () => import('@/view/employee/list'),
            name: 'listEmployee',
            hidden: true
          },
          {
            path: '/account/employee/add',
            component: () => import('@/view/employee/add'),
            name: 'addEmployee',
            hidden: true
          }
        ]
      }
    ]
  }]
}

export default accountRouter
